const KEY = 'gc:sound';
let scanning, reveal;

export function isSoundOn() {
  return localStorage.getItem(KEY) === 'on';
}

export function setSoundOn(on) {
  localStorage.setItem(KEY, on ? 'on' : 'off');
}

export async function loadAudio() {
  if (!scanning) scanning = new Audio('/audio/scanning.mp3');
  if (!reveal) reveal = new Audio('/audio/reveal.mp3');
  scanning.loop = true;
}

export function playScanning() {
  if (!isSoundOn() || !scanning) return;
  scanning.currentTime = 0;
  scanning.play().catch(() => {});
}

export function stopScanning() {
  if (!scanning) return;
  scanning.pause();
  scanning.currentTime = 0;
}

export function playReveal() {
  if (!isSoundOn() || !reveal) return;
  reveal.currentTime = 0;
  reveal.play().catch(() => {});
}
